import { render, staticRenderFns } from "./viewHoor.vue?vue&type=template&id=5c8d168b&scoped=true"
import script from "./viewHoor.vue?vue&type=script&lang=js"
export * from "./viewHoor.vue?vue&type=script&lang=js"
import style0 from "./viewHoor.vue?vue&type=style&index=0&id=5c8d168b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d168b",
  null
  
)

export default component.exports